var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1,
  d: "M14.25 7.556a.75.75 0 1 1 1.5 0V8.2a7.75 7.75 0 1 1-4.596-7.083.75.75 0 0 1-.61 1.37A6.25 6.25 0 1 0 14.25 8.2zm-7.82-.58L8 8.547l6.47-6.476a.75.75 0 0 1 1.06 1.06l-7 7.007a.75.75 0 0 1-1.06 0l-2.1-2.1a.75.75 0 0 1 1.06-1.06"
})));
export default SvgCheckCircle;